export enum UploadFileTypesEnum {
  KNM = 'Проект КНМ',
  KNM_PLAN_LIST = 'Список планов',
  PM_LIST = 'Список мероприятий',
  KNM_LIST = 'Список проверок',
  CHECKLIST_TEMPLATE = 'Проверочный лист',
  KNM_PLAN = 'План проверки',
  KNM_STATISTICS_BY_SUPERVISION_TYPE = 'Общая статистика КНМ по видам государственного контроля (надзора)',
  UNPLANNED_KNM_STATISTICS_BY_KNO = 'Общая статистика внеплановых КНМ (в разрезе КНО)',
  UNPLANNED_KNM_STATISTICS_BY_PROSECUTOR_AND_KNO = 'Общая статистика внеплановых КНМ (в разрезе органов прокуратуры и КНО)',
  UNPLANNED_KNM_STATISTICS_BY_PROSECUTOR = 'Общая статистика внеплановых КНМ (в разрезе органов прокуратуры)',
  PLANNED_KNM_STATISTICS_BY_PROSECUTOR_AND_KNO = 'Общая статистика плановых КНМ (в разрезе органов прокуратуры и КНО)',
  PLANNED_KNM_STATISTICS_BY_PROSECUTOR = 'Общая статистика плановых КНМ (в разрезе органов прокуратуры)',
  PLANNED_KNM_STATISTICS_BY_OPF = 'Общая статистика плановых КНМ по ОПФ включенных в сводный план проверок',
  PLANNED_KNM_STATISTICS_BY_REJECT_REASON = 'Общая статистика по основаниям отказа в проведении плановых КНМ',
  SPV_AND_TOR_REGISTER = 'Отчет по реестрам резидентов СПВ и ТОР',
  TOSER_AND_SEZ_REGISTER = 'Отчет по реестру ТОСЭР и СЭЗ',
  UNTIMELY_FILLED = 'Перечень КНМ в которых основные сведения заполнены несвоевременно',
  RESULT_IS_ABSENT_OR_LATE = 'Перечень КНМ в которых результат проведения отсутствует или внесен с опозданием',
  DECISION_APPEALED = 'Перечень КНМ решение по которым обжаловано',
  VIOLATIONS_DETECTED = 'Перечень КНМ с выявленными нарушениями',
  PRESCRIPTIONS_FULFILLED = 'Перечень КНМ с исполненными предписаниями',
  PLANNED_FOR_MONTH = 'Перечень планируемых к проведению в данном месяце КНМ',
  COMPLETED_WITHIN_MONTH = 'Перечень проведенных в данном месяце КНМ',
  APPROVED_KNM_PLAN = 'Согласованные проверки плана',
  APPROVED_KNM_PLAN_ERKNM = 'Утверждённые КНМ плана',
  KNM_MATCH_LIST = 'Совпадения',
  KNM_MATCH_BY_PERSON_LIST = 'Список совпадающих КНМ',
  EGRUL = 'Выписка ЕГРЮЛ',
  EGRIP = 'Выписка ЕГРИП',
  MSP = 'Выписка МСП',
  TOSER = 'Выписка ТОСЭР',
  SPV = 'Выписка СПВ',
  OEZ = 'Выписка ОЭЗ',
  KNM_MATCH_BY_PLAN = 'Совпадения по плану (По субъекту РФ)',
  KNM_MATCH_BY_PLAN_ALL = 'Совпадения по плану (По всей РФ)',
  KNM_MATCH_BY_KNM = 'Совпадения по КНМ',
  PLAN_DOCUMENTS_FOR_KNO = 'Комплект документов для КНО',
  ANALYTICS_TABLE = 'Аналитика',
  KNM_FROM_SMEV_START_DATE = 'Общая статистика КНМ, размещенных с помощью СМЭВ (в разрезе даты начала КНМ)',
  KNM_FROM_SMEV_RECEIVED_DATE = 'Общая статистка КНМ, размещенных с помощью СМЭВ (в разрезе даты обработки запроса)',
  RESULT_KNM_BY_PROSECUTOR_AND_KNO = 'Общая статистика результатов проведения КНМ (в разрезе органов прокуратуры и КНО)',
  VIOLATIONS_KNM_BY_PROSECUTOR_AND_KNO = 'Общая статистика нарушений проведения КНМ (в разрезе органов прокуратуры и КНО)',
  ERKNM_KIND_DECISION_TYPE_BY_PROSECUTOR_AND_KNO = 'Общая статистика видов решений проведения КНМ (в разрезе органов прокуратуры и КНО)',
  ERKNM_ACT_VIOLATION_TYPE_BY_PROSECUTOR_AND_KNO = 'Общая статистика по актам КНМ (в разрезе органов прокуратуры и КНО)',
  SUPERVISION_WEB_COMPLAINT_OF_KNO = 'Жалоба КНО о включении (невключении) проверки в план',
  NEW_PROJECT_WEB_NOTIFICATION = 'Уведомление о новом проекте плана',
  COMPLETE_KNM_PLAN = 'Полный план КНМ',
  REVIEW_WITHOUT_COMMENTS_WEB_NOTIFICATION = 'Уведомление о рассмотрении без замечаний',
  REVIEW_WITH_COMMENTS_WEB_NOTIFICATION = 'Уведомление о рассмотрении с замечаниями',
  SUPERVISION_WEB_STATEMENT_OF_AGREEMENT = 'Заявление о согласовании с прокурором',
  SUPERVISION_WEB_DECISION_ON_APPLICATION = 'Решение прокурора по заявлению',
  ADD_KNM_IN_PLAN_WEB_NOTIFICATION = 'Уведомление о добавлении проверки в согласованный план',
  EXCLUSION_KNM_FROM_PLAN_WEB_NOTIFICATION = 'Уведомление об исключении проверки из согласованного плана',
  ADD_CHANGES_IN_KNM_PASSPORT_WEB_NOTIFICATION = 'Уведомление о внесении изменений в паспорт КНМ в согласованном плане',
  PM = 'Профилактическое мероприятие',
  CONSIDERED_KNM_PLAN = 'Рассмотренные КНМ плана',
  ANALYTICS_PROSECUTOR_ORGANIZATIONS_TABLE = 'Выгрузка аналитики в разрезе прокуратуры',
  ERKNM_UNPLANNED_KNM_BY_KNO = 'Общая статистика внеплановых КНМ (в разрезе КНО)',
  ERKNM_KNM_DECISION_APPEALED = 'Перечень КНМ решение по которым обжаловано',
  ERKNM_KNM_CARRIED_OUT_BY_MONTH = 'Перечень проведенных в данном месяце КНМ',
  ERKNM_SPV_AND_TOR_REGISTER = 'Отчет по реестрам резидентов ТОСЭР И СПВ',
  ERKNM_TOSER_AND_SEZ_REGISTER = 'Отчет по реестру ТОСЭР И ОЭЗ',
  ERKNM_UNPLANNED_KNM_BY_PROSECUTOR = 'Общая статистика внеплановых КНМ (в разрезе органов прокуратуры)',
  ERKNM_UNPLANNED_KNM_BY_PROSECUTOR_AND_KNO = 'Общая статистика внеплановых КНМ (в разрезе органов прокуратуры и КНО)',
  ERKNM_STATISTICS_BY_SUPERVISION_TYPE = 'Общая статистика КНМ по видам государственного контроля (надзора)',
  ERKNM_PLANNED_KNM_BY_PROSECUTOR = 'Общая статистика плановых КНМ (в разрезе органов прокуратуры)',
  ERKNM_PLANNED_KNM_BY_KNO_AND_PROSECUTOR = 'Общая статистика плановых КНМ (в разрезе органов прокуратуры и КНО)',
  ERKNM_STATISTICS_BY_REJECT_REASON_TYPE = 'Общая статистика по основаниям отказа в проведении внеплановых КНМ',
  ERKNM_KNM_PLANNED_BY_MONTH = 'Перечень планируемых к проведению в данном месяце КНМ',
  ERKNM_PM_BY_KNO = 'Общая статистика ПМ (в разрезе КНО)',
  ERKNM_PM_BY_SUPERVISION_TYPE = 'Общая статистика ПМ по видам государственного контроля (надзора)',
  ERKNM_PM_PLANNED_BY_MONTH = 'Перечень планируемых к проведению в данном месяце ПМ',
  ERKNM_PM_CARRIED_OUT_BY_MONTH = 'Перечень проведенных в данном месяце ПМ',
  ERKNM_PM_DECISION_APPEALED = 'Перечень ПМ решение по которым обжаловано',
  KNM_VERSION = 'Пакет документов версии КНМ',
  KNM_PLAN_VERSION = 'Пакет документов версии плана',
  ERKNM_PLAN_CORRECTION = 'Корректировка плана ЕРКНМ',
  ERKNM = 'Проект паспорта ЕРКНМ',
  ERKNM_CORRECTION = 'Корректировка паспорта ЕРКНМ',
  KNM_CORRECTION = 'Корректировка КНМ',
  CHECKLIST = 'Проверочный лист',
  PLAN = 'Проект плана КНМ',
  PLAN_CORRECTION = 'Корректировка плана КНМ',
  PASSPORT_GROUP = 'Группа мероприятий',
  ERKNM_KNM_CARRIED_OUT_BY_RF_REGION = 'Перечень всех проведенных КНМ (в разрезе субъектов РФ)',
  ERKNM_PM_CARRIED_OUT_BY_RF_REGION = 'Перечень всех проведенных ПМ (в разрезе субъектов РФ)',
}
